module.exports = __webpack_public_path__ + "img/home-slide1-gr-2x.a72af816.png";